<template>
  <div class="projectApplyDetail">
    <div class="title">
      <div class="type">项目立项申请</div>
      <div class="name">{{ form.projectName }}</div>
      <div class="no">单号：{{ form.id }}</div>
    </div>
    <div style="display: flex; flex-direction: row">
      <div style="flex: 1">
        <div class="projectInfo">
          <el-form :model="form" ref="form" label-width="90px">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="项目名称:" prop="projectName">
                  <el-input
                    v-model="form.projectName"
                    placeholder="请输入项目名称"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目经理:" prop="managerName">
                  <el-input
                    readonly
                    v-model="form.managerName"
                    placeholder="请填写项目经理"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="合同名称:" prop="contractName">
                  <el-input readonly v-model="form.contractName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同编号:" prop="contractNo">
                  <el-input readonly v-model="form.contractNo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="项目总额:" prop="amount">
                  <el-input
                    readonly
                    v-model="form.amount"
                    placeholder="请输入项目总额"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目日期:" prop="date">
                  <el-date-picker
                    readonly
                    v-model="form.date"
                    value-format="yyyy-MM-dd"
                    style="width: 428px"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="详细说明:" prop="description">
                  <el-input
                    readonly
                    v-model="form.description"
                    maxLength="100"
                    placeholder="请输入合同说明，100字以内"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="派单人:" prop="distributeId">
                  <div @click="addPeople('distribute')">
                    <el-input
                      readonly
                      v-model="form.distributeName"
                      placeholder="请选择派单人"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- <el-form-item label="详细说明:" prop="description">
              <el-input
                readonly
                v-model="form.description"
                maxLength="100"
                placeholder="请输入合同说明，100字以内"></el-input>
            </el-form-item> -->
            <div style="font-size: 16px; font-weight: 600; padding: 10px 0">
              项目清单(合同内)
              <el-button
                v-if="canEdit"
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="saveItemList"
              >
                保存清单
              </el-button>
            </div>
            <div>
              <el-row
                style="margin-top: 10px; margin-bottom: 10px"
                :gutter="24"
              >
                <el-col :span="5">
                  <div class="xingxing">工作项</div>
                </el-col>
                <el-col :span="3">
                  <div>规格</div>
                </el-col>
                <el-col :span="3">
                  <div class="xingxing">工程量</div>
                </el-col>
                <el-col :span="2">
                  <div>单位</div>
                </el-col>
                <el-col :span="3">
                  <div class="xingxing">单价（元）</div>
                </el-col>
                <el-col :span="2">
                  <div>分项汇总</div>
                </el-col>
                <el-col :span="5">
                  <div>备注</div>
                </el-col>
                <el-col :span="1">
                  <div></div>
                </el-col>
              </el-row>
              <el-row
                v-for="(item, index) in form.itemList"
                :key="'workList' + index"
                :gutter="24"
              >
                <el-col :span="5">
                  <el-form-item
                    labelWidth="0"
                    :prop="`itemList[${index}].workItemId`"
                  >
                    <el-input readonly v-model="item.workItemName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item labelWidth="0">
                    <div>{{ item.specName || "-" }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item
                    labelWidth="0"
                    :prop="`itemList[${index}].quantity`"
                  >
                    <el-input
                      :readonly="!canEdit"
                      v-model="item.quantity"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入工程量"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item labelWidth="0">
                    <div>{{ item.workItemUnitName }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item
                    labelWidth="0"
                    :prop="`itemList[${index}].price`"
                  >
                    <el-input
                      :readonly="!canEdit"
                      v-model="item.price"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入单价"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item labelWidth="0">
                    <div>
                      ￥{{ (item.quantity * item.price) | filterMoney }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item labelWidth="0" prop="remark">
                    <el-input
                      :readonly="!canEdit"
                      v-model="item.remark"
                      placeholder="请输入备注"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="1"> </el-col> -->
              </el-row>
            </div>
            <div
              style="
                border-bottom: 1px solid #ccc;
                width: 100%;
                height: 40px;
                padding-bottom: 20px;
              "
            >
              <div style="float: right; height: 40px; line-height: 40px">
                总计：
                <span style="color: red">￥{{ allMoney }}</span>
              </div>
            </div>
            <template>
              <div style="font-size: 16px; font-weight: 600; padding: 10px 0">
                地域范围
                <span style="font-size: 12px; font-weight: 400">
                  （最小可分解区域）
                </span>
              </div>
              <div
                style="
                  border-bottom: 1px solid #ccc;
                  width: 100%;
                  padding: 10px 0 20px 0;
                "
              >
                <template>
                  <div
                    class="areaItem"
                    v-for="(item, index) in form.roadList"
                    :key="index"
                  >
                    <li class="el-icon-location"></li>
                    <div class="areaName">{{ item.roadName }}</div>
                  </div>
                </template>
              </div>
            </template>
            <el-input
              readonly
              style="margin-top: 20px"
              type="textarea"
              :rows="4"
              v-model="form.content"
              placeholder="请输入项目补充内容"
            ></el-input>
          </el-form>
        </div>
      </div>
      <work-flow :list="flowList"></work-flow>
    </div>
    <div v-if="!canProval" class="foot">
      <el-button type="primary" @click="$router.back()">确定</el-button>
    </div>
    <div v-else class="foot">
      <el-button type="primary" @click="applySuccess">通过</el-button>
      <el-button type="danger" @click="applyBack" plain>驳回</el-button>
      <!-- <el-button
        v-if="form.auditFlowStepIsLast === 1"
        type="danger"
        @click="cancelProject">
        作废
      </el-button> -->
    </div>
    <el-dialog
      :visible.sync="aprovalVisible"
      :title="dialogTitle"
      width="400px"
    >
      <el-input v-model="desc" type="textarea" :rows="4"></el-input>

      <div style="margin-top: 20px">
        <el-button @click="aprovalVisible = false">取消</el-button>
        <el-button
          v-if="flag === 2"
          type="danger"
          @click="approvalSubmit(flag)"
        >
          驳回
        </el-button>
        <el-button
          v-else-if="flag === 1"
          type="primary"
          @click="approvalSubmit(flag)"
        >
          通过
        </el-button>
        <el-button v-else-if="flag === 3" type="danger" @click="cancelSubmit()">
          作废
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WorkFlow from "./components/WorkFlow.vue";
import ProjectApplyApi from "@/api/projectApply";
import { mapGetters } from "vuex";
export default {
  name: "ProjectApplyDetail",
  components: {
    WorkFlow,
  },
  data() {
    return {
      flag: 0,
      workItemOptions: [],
      flowList: [],
      historyItem: {},
      desc: "",
      canProval: false,
      aprovalVisible: false,
      dialogTitle: "",
      form: {
        actionType: "", //0：暂存 1：提交
        amount: "",
        content: "",
        contractName: "",
        contractNo: "",
        description: "",
        endDate: "",
        date: [],
        itemList: [
          {
            amount: "",
            price: "",
            quantity: "",
            remark: "",
            workItemId: "",
            workItemName: "",
            workItemUnitName: "",
          },
        ],
        managerId: "",
        managerName: "",
        projectName: "",
        startDate: "",
        total: 0,
        distributeId: "",
        distributeName: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    canEdit() {
      // 只有管理员和项目经理可以编辑清单
      return (
        this.userInfo.role === "admin" ||
        this.userInfo.role === "project_manager"
      );
    },
    allMoney() {
      // console.log('getallmoney')
      let sum = 0;
      if (this.form.itemList) {
        this.form.itemList.forEach((item) => {
          if (!isNaN(item.quantity * item.price)) {
            sum += item.quantity * item.price;
          }
        });
      }

      return sum;
    },
  },
  filters: {
    filterMoney(val) {
      if (isNaN(val)) {
        return 0;
      } else {
        return val;
      }
    },
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getAllWorkLit();
    this.getDetail();
  },
  methods: {
    saveItemList() {
      // 保存清单修改
      ProjectApplyApi.updateProjectItemList({
        id: this.form.id,
        itemList: this.form.itemList,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: "清单保存成功",
              type: "success",
            });
            this.getDetail(); // 重新获取详情以更新数据
          } else {
            this.$message({
              message: res.data.message || "清单保存失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "清单保存失败",
            type: "error",
          });
        });
    },
    getDetail() {
      if (this.id) {
        ProjectApplyApi.queryProjectDetail({
          id: this.id,
        }).then((res) => {
          Object.assign(this.form, res.data.data);
          this.form.date = [];
          this.form.date.push(new Date(this.form.startDate));
          this.form.date.push(new Date(this.form.endDate));
          this.flowList = this.form.auditFlow.auditFlowHistoryList;
          if (this.form.status === 1) {
            this.flowList.forEach((item) => {
              if (
                item.stepId === this.form.auditFlowStepId &&
                this.userInfo.employeeId === item.auditId &&
                item.auditStatus === 0
              ) {
                this.canProval = true;
                this.historyItem = item;
              }
            });
          }
        });
      }
    },
    getAllWorkLit() {
      ProjectApplyApi.queryAllWorkItem().then((res) => {
        if (res.data.code === 200) {
          this.workItemOptions = res.data.data.map((item) => {
            item.allName = item.workName + "-" + item.itemName;
            return item;
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    applyBack() {
      this.aprovalVisible = true;
      this.desc = "";
      this.flag = 2;
      this.dialogTitle = "审批意见";
    },
    applySuccess() {
      this.aprovalVisible = true;
      this.desc = "";
      this.flag = 1;
      this.dialogTitle = "审批意见";
    },
    approvalSubmit(val) {
      ProjectApplyApi.auditProject({
        auditDescription: this.desc,
        auditStatus: val,
        historyId: this.historyItem.id,
        projectId: this.form.id,
      }).then((res) => {
        if (res.data.code === 200) {
          let msg = val === 1 ? "审核通过" : "驳回成功";
          //	审核状态，1：审核通过 2：审核驳回
          this.$message({
            message: msg,
            type: "success",
          });
          this.aprovalVisible = false;
          this.canProval = false;
          this.getDetail();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    cancelProject() {
      this.aprovalVisible = true;
      this.desc = "";
      this.flag = 3;
      this.dialogTitle = "作废意见";
    },
    cancelSubmit() {
      ProjectApplyApi.cancelProject({
        id: this.form.id,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: "作废成功",
            type: "success",
          });
          this.aprovalVisible = false;
          this.canProval = false;
          this.getDetail();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.projectApplyDetail {
  // display: flex;
  // flex-direction: row;
  overflow: hidden;
  overflow-y: auto;
  .el-form-item {
    margin-left: 0 !important;
  }
  .title {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid #ccc;
    .backButton {
      width: 40px;
      font-size: 20px;
    }
    .type {
      height: 30px;
      line-height: 30px;
      background-color: #67c23a;
      padding: 0 6px;
      margin-top: 8px;
      margin-left: 10px;
      color: white;
      border-radius: 4px;
    }
    .name,
    .no {
      height: 46px;
      line-height: 46px;
      margin-left: 20px;
    }
    .name {
      font-weight: 600;
    }
  }

  .projectInfo {
    width: 1100px;
    padding: 20px;
    .areaItem {
      width: auto;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      position: relative;
      border: 1px solid #ccc;
      margin-right: 20px;
      padding: 0 6px;
      li {
        font-size: 20px;
      }
      .areaName {
        display: inline-block;
        margin-left: 6px;
        vertical-align: top;
      }
      .deleteBtn {
        position: absolute;
        right: -8px;
        top: -8px;
        font-size: 20px;
        color: red;
        cursor: pointer;
      }
    }
    .xingxing::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
  .foot {
    width: 100%;
    padding: 20px;
    padding-top: 0;
  }
}
</style>
